<template>
    <div class="flex space-x-2 h-[46px]">
        <!-- Hiển thị key -->
        <p>
            {{ isFullView ? fullKey : formattedKey }}
        </p>

        <span>
            <hi-eye-slash-icon
                v-if="isFullView"
                class="h-4 w-4"
                @click="toggleView" />

            <hi-eye-icon
                v-else
                class="h-4 w-4"
                @click="toggleView" />
        </span>
    </div>
</template>

<script lang="ts" setup>
import { defineProps, toRefs, computed, ref } from 'vue'

const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

// Biến lưu trạng thái đóng/mở
const isFullView = ref(false)

// Key đầy đủ
const fullKey = computed(() => params?.value?.data?.key || '')

// Key định dạng
const formattedKey = computed(() => {
  const key = fullKey.value
  const visibleLength = 10 // Số ký tự đầu hiển thị
  const hiddenLength = key.length - visibleLength
  const hiddenStars = '*'.repeat(hiddenLength) // Chuỗi `*` với số lượng ký tự bị ẩn
  return key.length > visibleLength ? `${key.slice(0, visibleLength)}${hiddenStars}` : key
})

// Hàm toggle đóng/mở
const toggleView = () => {
  isFullView.value = !isFullView.value
}
</script>

<style scoped>
/* Thêm style nếu cần */
</style>
